$(window).on("load",function(){
 
  $(".venobox").venobox({         // default: ''
        titleattr: 'data-title',    // default: 'title'
        numeratio: true,            // default: false
                             infinigall: true,
        bgcolor:'white'})
  })